import type { AgentsTranslations } from '../interfaces/agents';

export const agentsTranslations: AgentsTranslations = {
  page_title: 'Agentes',
  page_description:
    'Gestiona los agentes IA que responden por ti. Crea uno por caso de uso y ajusta su configuración.',
  empty_title: 'Aún no tienes agentes',
  empty_description:
    'Crea tu primer agente para empezar a automatizar conversaciones con tus clientes.',
  create_button: 'Crear agente',
  back_to_list: 'Volver a agentes',

  agent_type_ecommerce: 'E-commerce',
  agent_type_real_estate: 'Inmobiliaria',
  agent_type_fintech: 'Fintech',
  template_ecommerce_default: 'Defaults de e-commerce',
  template_real_estate_default: 'Defaults inmobiliarios',
  template_fintech_default: 'Defaults fintech',
  template_empty: 'Vacío',

  status_active: 'Activo',
  status_inactive: 'Inactivo',
  status_draft: 'Borrador',

  card_actions_label: 'Acciones del agente',
  action_edit: 'Editar',
  action_duplicate: 'Duplicar',
  action_activate: 'Activar',
  action_deactivate: 'Desactivar',
  action_mark_draft: 'Mover a borrador',
  action_unmark_draft: 'Sacar de borrador',
  action_delete: 'Eliminar',

  create_page_title: 'Crear nuevo agente',
  create_page_description:
    'Elige un nombre y una plantilla inicial. Después podrás ajustarlo todo al detalle.',
  create_tab_manual: 'Manual',
  create_tab_files: 'Subir archivos',
  create_field_name_label: 'Nombre',
  create_field_name_placeholder: 'Ej. Mi Tienda – WhatsApp',
  create_field_name_help: 'Debe ser único dentro de tu organización.',
  create_field_type_label: 'Tipo de agente',
  create_field_template_label: 'Plantilla inicial',
  create_field_template_help:
    'La plantilla rellena valores por defecto; puedes sobrescribir todo después.',
  create_submit: 'Crear agente',
  create_files_section_title: 'Archivos fuente (opcional)',
  create_files_section_description:
    'Suelta documentos (PDF, DOCX, TXT, MD, CSV) que describan tu negocio. Se usarán para autocompletar la configuración cuando el pipeline de ingesta esté listo.',
  create_files_pending_notice:
    'El procesamiento de archivos está en preparación. Los archivos quedan adjuntos al borrador y serán procesados cuando el backend lo soporte.',

  dropzone_idle: 'Arrastra archivos aquí o haz clic para buscar',
  dropzone_active: 'Suelta los archivos para adjuntarlos',
  dropzone_hint: 'PDF, DOCX, TXT, MD, CSV — hasta 10 archivos, 20 MB cada uno.',
  dropzone_remove: 'Quitar archivo',
  dropzone_size_unit_b: 'B',
  dropzone_size_unit_kb: 'KB',
  dropzone_size_unit_mb: 'MB',

  duplicate_dialog_title: 'Duplicar agente',
  duplicate_dialog_description:
    'Elige un nuevo nombre. Se copia toda la configuración; el duplicado queda activo.',
  duplicate_dialog_field_label: 'Nuevo nombre',
  duplicate_dialog_confirm: 'Duplicar',
  duplicate_dialog_cancel: 'Cancelar',

  delete_dialog_title: '¿Eliminar este agente?',
  delete_dialog_description:
    'Dejará de responder mensajes de inmediato. Es eliminación lógica; el nombre no se libera.',
  delete_dialog_confirm: 'Eliminar agente',
  delete_dialog_cancel: 'Cancelar',

  edit_page_loading: 'Cargando agente…',
  edit_page_not_found_title: 'Agente no encontrado',
  edit_page_not_found_description:
    'Puede haber sido eliminado o no tener acceso. Vuelve al listado e inténtalo de nuevo.',
  edit_save: 'Guardar cambios',
  edit_saving: 'Guardando…',
  edit_discard: 'Descartar cambios',
  edit_no_changes_hint: 'No hay cambios sin guardar.',
  edit_field_name_label: 'Nombre',
  edit_schema_loading: 'Cargando esquema de configuración…',
  edit_schema_error: 'No pudimos cargar el esquema de configuración.',
  edit_schema_retry: 'Reintentar',
  edit_view_mode_form: 'Formulario',
  edit_view_mode_json: 'JSON',
  edit_nav_search_placeholder: 'Buscar secciones…',
  edit_nav_group_label: 'Configuración del agente',
  edit_test_with_customer: 'Probar con cliente',
  edit_test_with_customer_coming_soon: 'Próximamente',
  edit_view_in_production: 'Ver en producción',
  edit_view_in_production_inactive: 'Activa primero el agente',
  edit_breadcrumb_root: 'Agentes',
  edit_unsaved_pill: 'Cambios sin guardar',

  hero_agent_label: 'Agente',
  hero_agent_of: 'Agente de',
  hero_subtitle:
    'Todo lo que puedes configurar en este agente: identidad, modelo, tono, datos, objetivos, handoffs y follow-ups.',
  identity_sandbox: 'Probar en sandbox',
  identity_timezone_label: 'Zona horaria',
  identity_timezone_placeholder: 'Elige una zona horaria…',
  identity_status_label: 'Estado',
  identity_status_help: 'Usa el menú de acciones para activar o pausar.',
  identity_status_inline_hint:
    'El estado se gestiona desde el menú de acciones en la barra superior.',

  llm_main_title: 'Modelo principal',
  llm_model_label: 'Modelo',
  llm_model_placeholder: 'Selecciona un modelo…',
  llm_overrides_title: 'Overrides por tarea',
  llm_overrides_description:
    'Usa un modelo distinto para tareas específicas (clasificación, extracción, perfilado).',
  llm_overrides_placeholder:
    'Los overrides por tarea llegarán pronto. Mientras tanto, el modelo principal se usará para todas las tareas.',

  tone_preferred_title: 'Palabras preferidas',
  tone_preferred_help: 'Vocabulario de marca que el agente debe priorizar.',
  tone_forbidden_title: 'Palabras prohibidas',
  tone_forbidden_help: 'Se evitan siempre y se bloquean en las respuestas.',
  tone_guard_title: 'Temas dentro del alcance',
  tone_guard_help:
    'Temas que el guard NO debe bloquear. El agente los puede tratar aunque al inicio parezcan fuera de contexto.',
  field_guard_topics_label: 'Temas dentro del alcance',
  field_guard_topics_help:
    'Lista de temas que el guard considera "dentro de tema". Útil para casos donde el cliente menciona algo emocional o tangencial que sigue siendo parte del contexto de la marca (p. ej. "amor", "dinero", "ansiedad").',

  examples_add: 'Agregar ejemplo',
  examples_question_label: 'Pregunta del cliente',
  examples_answer_label: 'Respuesta ideal',
  examples_remove: 'Eliminar ejemplo',
  examples_empty: 'Aún no hay ejemplos — se recomiendan 4-8.',
  examples_counter: '{{count}} ejemplos · se recomiendan 4-8',

  prompt_helper:
    '{{count}} caracteres · se inyecta después de la descripción de marca y el tono',

  data_add: 'Agregar campo',
  data_remove: 'Eliminar campo',
  data_required_label: 'Campo requerido',
  data_empty: 'Aún no hay campos configurados.',
  data_col_key: 'Clave',
  data_col_display: 'Nombre visible',
  data_col_type: 'Tipo',
  data_col_stage: 'Etapa',

  data_group_label: 'Grupo {{index}}',
  data_group_when_prefix: 'Si',
  data_group_always_active: 'Siempre activo',
  data_group_field_count: '{{count}} campos',
  data_group_condition_hint:
    'Las condiciones son de solo lectura hasta que el backend las exponga.',
  data_group_empty: 'Aún no hay campos en este grupo.',
  data_group_add: 'Agregar grupo',
  data_group_remove: 'Eliminar grupo',
  data_field_add: 'Agregar campo',
  data_field_display_placeholder: 'p. ej. Correo del cliente',
  data_field_key_label: 'Clave',
  data_field_key_help:
    'Identificador en snake_case que se guarda en el CRM. Se genera automático desde el nombre visible; edítalo solo si es necesario.',
  data_field_key_hint: 'Clave interna usada por el CRM y las integraciones.',
  data_field_type_label: 'Tipo',
  data_field_stage_label: 'Etapa',
  data_field_options_label: 'Opciones válidas',
  data_field_options_help:
    'Lista de valores permitidos. El agente solo puede guardar uno de estos.',
  data_field_options_placeholder: 'Escribe y presiona Enter…',
  data_field_question_label: 'Plantilla de pregunta',
  data_field_question_help:
    'El agente la usa como plantilla — el modelo puede parafrasearla según el tono.',
  data_field_question_placeholder: 'p. ej. ¿Cuál es tu correo?',
  data_field_validation_label: 'Regla de validación',
  data_field_validation_help:
    'Regla en texto libre que el modelo aplica (p. ej. "debe contener @").',
  data_field_validation_placeholder: 'p. ej. formato de email válido',
  data_field_required_label: 'Requerido',
  data_field_required_chip: 'Requerido',
  data_field_required_help:
    'Debe recolectarse antes de cerrar la conversación.',
  data_field_extractable_label: 'Extraíble desde media',
  data_field_extractable_help:
    'Si está activo, el agente puede extraer este dato desde una foto o audio (p. ej. una receta médica).',
  data_field_advanced_toggle: 'Avanzado',

  labels_add: 'Agregar etiqueta',
  labels_remove: 'Eliminar etiqueta',
  labels_empty: 'Aún no hay etiquetas configuradas.',
  labels_col_key: 'Clave',
  labels_col_display: 'Nombre visible',
  labels_col_tone: 'Color',

  capabilities_title: 'Capacidades',
  capabilities_empty:
    'Sin capacidades definidas. Agrega lo que el agente sí puede hacer.',
  capabilities_add: 'Agregar capacidad',
  capabilities_what_label: '¿Qué puede hacer?',
  capabilities_what_placeholder: 'Ej. Tomar pedidos, recomendar productos',
  capabilities_desc_label: 'Detalle',
  capabilities_desc_placeholder:
    'Cómo lo hace, en qué casos, ejemplos de uso',
  limitations_title: 'Nunca hace',
  limitations_empty:
    'Sin límites definidos. Agrega lo que el agente NO debe hacer.',
  limitations_add: 'Agregar límite',
  limitations_what_label: '¿Qué NO puede hacer?',
  limitations_what_placeholder: 'Ej. Agendar citas, dar diagnósticos médicos',
  limitations_desc_label: 'Detalle',
  limitations_desc_placeholder:
    'Cómo se manifiesta, qué evitar exactamente',
  limitations_redirect_label: 'Mensaje exacto cuando lo pidan (opcional)',
  limitations_redirect_placeholder:
    'Ej. "Para agendar escríbenos a soporte@..."',
  limitations_redirect_hint:
    'Si lo dejas vacío, el agente responderá amablemente que no puede sin prometerlo.',
  common_remove: 'Quitar',

  goal_milestones_title: 'Hitos antes del CTA',
  goal_milestones_add: 'Agregar hito',
  goal_milestones_remove: 'Eliminar hito',
  goal_opening_title: 'Apertura de la conversación',
  goal_opening_description:
    'Cómo saluda el agente en el primer turno y ejemplos concretos.',
  goal_opening_examples_label: 'Ejemplos de apertura',
  goal_opening_examples_add: 'Agregar ejemplo',
  goal_opening_examples_remove: 'Eliminar ejemplo',

  messaging_preview_label: 'Vista previa aproximada',

  rag_enabled_title: 'Retrieval-Augmented Generation',
  rag_enabled_description:
    'Cuando está activo, el agente busca en tus fuentes antes de responder.',
  rag_sources_hint:
    'Administra las fuentes cargadas desde la sección de Fuentes arriba.',
  rag_tools_title: 'Herramientas externas',
  rag_tools_description:
    'Funciones que el agente puede llamar (APIs, bases de datos, webhooks).',
  rag_tools_empty: 'No hay herramientas conectadas todavía.',

  handoff_enabled_title: 'Pasar a un humano',
  handoff_enabled_description:
    'Cuando está activo, el agente se detiene y notifica a un humano si alguna condición se cumple.',
  handoff_col_type: 'Tipo',
  handoff_col_value: 'Disparador',
  handoff_col_reason: 'Razón',
  handoff_add: 'Agregar disparador',
  handoff_remove: 'Eliminar disparador',

  toast_created: 'Agente creado.',
  toast_updated: 'Agente actualizado.',
  toast_duplicated: 'Agente duplicado.',
  toast_activated: 'Agente activado.',
  toast_deactivated: 'Agente desactivado.',
  toast_drafted: 'Agente movido a borrador.',
  toast_undrafted: 'Agente sacado de borrador.',

  wizard_step_basics: 'Datos básicos',
  wizard_step_docs: 'Documentos',
  wizard_choice_empty_title: 'Empezar desde cero',
  wizard_choice_empty_description:
    'Crea un agente vacío y configura todo manualmente.',
  wizard_choice_from_docs_title: 'Generar desde documentos',
  wizard_choice_from_docs_description:
    'Sube de 1 a 10 documentos y te pre-llenamos el agente.',
  wizard_continue: 'Continuar',
  wizard_back: 'Atrás',
  wizard_generate_button: 'Generar agente',
  wizard_skip_to_create: 'Saltar — crear vacío',
  wizard_files_required: 'Agrega al menos un archivo para generar.',

  generation_status_queued: 'En cola…',
  generation_status_running: 'Generando tu agente…',
  generation_status_failed: 'La generación falló',
  generation_status_success: '¡Listo!',
  generation_progress_label: '{{completed}} de {{total}} pasos',

  generation_node_document_loader: 'Leyendo los documentos',
  generation_node_language_detector: 'Detectando el idioma',
  generation_node_brand_extractor: 'Capturando la voz de marca',
  generation_node_domain_extractor: 'Mapeando el negocio',
  generation_node_qa_extractor: 'Armando la base de conocimiento',
  generation_node_link_extractor: 'Recopilando enlaces',
  generation_node_data_fields_suggester: 'Eligiendo qué preguntar',
  generation_node_config_synthesizer: 'Componiendo el agente',

  generation_error_first_title: 'Algo salió mal',
  generation_error_first_description:
    'No pudimos terminar de generar el agente. Inténtalo de nuevo.',
  generation_error_retry_button: 'Reintentar',
  generation_error_persistent_title: 'Sigue fallando',
  generation_error_persistent_description:
    'Hay un problema persistente. Espera unos minutos y vuelve a intentar, o abre el editor para configurarlo manualmente — tu borrador está guardado.',
  generation_error_go_to_editor_button: 'Abrir editor',

  toast_generation_success: 'Tu agente está listo.',
  toast_generation_failed: 'No se pudo generar el agente.',
  toast_deleted: 'Agente eliminado.',
  toast_files_pending:
    'Los archivos quedaron adjuntos localmente; se procesarán cuando el backend lo soporte.',

  error_display_name_taken:
    'Ese nombre ya está en uso dentro de tu organización.',
  error_validation:
    'Hay campos con valores inválidos. Revísalos e inténtalo de nuevo.',
  error_validation_summary:
    '{{count}} campos tienen valores inválidos. Primero: {{first}}',
  error_load_list: 'No pudimos cargar tus agentes. Inténtalo de nuevo.',
  error_load_one: 'No pudimos cargar este agente.',
  error_load_schema: 'No pudimos cargar el esquema de configuración.',
  error_agent_type_not_allowed:
    'Tu organización no puede crear agentes de este tipo.',
  error_unknown: 'Algo salió mal. Inténtalo de nuevo.',

  create_loading_types: 'Cargando tipos de agente disponibles…',
  create_no_types_title: 'Sin tipos de agente disponibles',
  create_no_types_description:
    'Tu organización aún no tiene tipos de agente habilitados. Contacta a soporte para activarlos.',

  sources_section_title: 'Archivos fuente (RAG)',
  sources_section_description:
    'Sube documentos que describan tu negocio. El agente los usa como base de conocimiento en cada respuesta.',
  sources_empty_title: 'Aún no hay archivos',
  sources_empty_description:
    'Arrastra un PDF, DOCX, TXT, MD, CSV o XLSX para alimentar al agente.',
  sources_upload_hint:
    'Arrastra archivos o haz clic — PDF, DOCX, TXT, MD, CSV, XLSX. Hasta 10 MB cada uno.',
  sources_upload_active: 'Suelta los archivos para añadirlos',
  sources_uploading: 'Subiendo {{name}}…',
  sources_pending_title: 'Listos para subir ({{count}})',
  sources_pending_remove: 'Quitar archivo',
  sources_pending_clear: 'Quitar todos',
  sources_pending_upload: 'Subir {{count}}',
  sources_pending_uploading: 'Subiendo…',
  sources_loading: 'Cargando archivos…',
  sources_load_error: 'No pudimos cargar los archivos.',
  sources_retry: 'Reintentar',

  source_status_processing: 'Procesando…',
  source_status_ready: 'Listo',
  source_status_failed: 'Error',
  source_qa_disabled: 'Q&A desactivado',
  source_qa_pending: 'Q&A en cola',
  source_qa_processing: 'Generando Q&A…',
  source_qa_ready: 'Q&A listo',
  source_qa_failed: 'Q&A falló',
  source_qa_label: 'Generar archivo Q&A automático',
  source_qa_help:
    'Creamos un archivo de preguntas y respuestas a partir de este documento. Mejora significativamente la calidad del RAG. (Recomendado)',
  source_active_label: 'Activo',
  source_active_help:
    'Si lo desactivas, el agente deja de consultarlo en sus respuestas.',
  source_pair_count: '{{count}} pares Q&A',
  source_updated_ago: 'Actualizado {{when}}',

  source_action_preview: 'Ver archivo',
  source_action_preview_qa: 'Ver Q&A',
  source_action_regenerate_qa: 'Regenerar Q&A',
  source_action_delete: 'Eliminar',

  source_delete_title: '¿Eliminar este archivo?',
  source_delete_description:
    'Se borra del almacenamiento y deja de formar parte del conocimiento del agente al instante.',
  source_delete_confirm: 'Eliminar archivo',

  toast_source_uploaded: 'Archivo subido — procesando en segundo plano.',
  toast_source_updated: 'Archivo actualizado.',
  toast_source_deleted: 'Archivo eliminado.',
  toast_source_qa_queued: 'Regeneración de Q&A en cola.',
  toast_source_preview_opened: 'Abriendo vista previa…',

  error_source_file_too_large: 'El archivo supera el límite de 10 MB.',
  error_source_unsupported:
    'Formato no soportado. Usa PDF, DOCX, TXT, MD, CSV o XLSX.',
  error_source_no_text:
    'No pudimos extraer texto del archivo. Prueba con otro documento.',
  error_source_qa_disabled: 'Debes habilitar Q&A antes de regenerarlo.',
  error_source_qa_not_generated: 'Este archivo aún no tiene Q&A generado.',
  error_source_upload: 'No pudimos subir el archivo. Inténtalo de nuevo.',
  error_source_delete: 'No pudimos eliminar el archivo.',
  error_source_update: 'No pudimos actualizar el archivo.',
  error_source_preview: 'No pudimos abrir el archivo.',

  preview_title: 'Vista previa',
  preview_loading: 'Cargando vista previa…',
  preview_fetch_error: 'No pudimos cargar el archivo para la vista previa.',
  preview_not_supported:
    'Vista previa no disponible para este tipo de archivo.',
  preview_csv_truncated:
    'Mostrando solo las primeras {{count}} filas. Descarga el archivo para ver todo.',
  preview_download: 'Descargar',

  qa_editor_title: 'Pares Q&A',
  qa_editor_pair_count: '{{count}} pares',
  qa_editor_add_pair: 'Agregar par',
  qa_editor_question_label: 'Pregunta',
  qa_editor_answer_label: 'Respuesta',
  qa_editor_remove_pair: 'Eliminar par',
  qa_editor_save: 'Guardar cambios',
  qa_editor_cancel: 'Cancelar',
  qa_editor_loading: 'Cargando pares Q&A…',
  qa_editor_fetch_error: 'No pudimos cargar los pares Q&A.',
  qa_editor_empty: 'Aún no hay pares. Agrega el primero.',

  toast_qa_content_saved: 'Pares Q&A guardados.',
  error_qa_content_save:
    'No pudimos guardar los pares Q&A. Inténtalo de nuevo.',

  section_identity_title: 'Identidad y marca',
  section_identity_subtitle:
    'Quién es el agente, qué voz tiene y en qué contexto opera.',
  section_llm_title: 'Modelo (LLM)',
  section_llm_subtitle:
    'El cerebro del agente. Puedes sobrescribir el modelo para tareas específicas como perfilado de leads.',
  section_tone_title: 'Tono y vocabulario',
  section_tone_subtitle:
    'Cómo habla el agente y qué palabras debe usar o evitar.',
  section_examples_title: 'Ejemplos de estilo',
  section_examples_subtitle:
    'Pares pregunta-respuesta que ilustran el tono ideal. El modelo los usa como few-shot.',
  section_prompt_title: 'Instrucciones del sistema',
  section_prompt_subtitle:
    'Reglas adicionales que se añaden al system prompt — políticas de producto, pagos y conversación.',
  section_data_title: 'Datos a recolectar',
  section_data_subtitle:
    'Información que el agente debe extraer durante la conversación. Define la pregunta, la etapa y las reglas de validación.',
  section_labels_title: 'Etiquetas',
  section_labels_subtitle:
    'El agente etiqueta automáticamente las conversaciones para segmentar leads y disparar workflows.',
  section_capabilities_title: 'Capacidades y límites',
  section_capabilities_subtitle:
    'Lo que el agente SÍ puede hacer, y lo que NUNCA debe hacer. Ambos se inyectan al system prompt.',
  section_goal_title: 'Objetivo del agente',
  section_goal_subtitle:
    'Qué busca lograr y qué tan agresivo es al llegar al CTA.',
  section_messaging_title: 'Estilo de mensajes',
  section_messaging_subtitle:
    'Cómo se estructuran las respuestas: largo, cantidad por turno y cómo se dividen.',
  section_rag_title: 'RAG y herramientas',
  section_rag_subtitle:
    'Base de conocimiento que el agente consulta en tiempo real, y herramientas externas que puede llamar.',
  section_handoff_title: 'Handoff a humano',
  section_handoff_subtitle:
    'Condiciones que detienen al agente y notifican a un humano para tomar el control.',
  section_followup_title: 'Follow-ups',
  section_followup_subtitle:
    'Cuándo el agente re-engagea al cliente si no responde o abandona.',
  section_integrations_title: 'Integraciones de conversión',
  section_integrations_subtitle:
    'Conecta Shopify u otro sistema para verificar las compras reales del agente.',

  integration_shopify_title: 'Shopify',
  integration_shopify_description:
    'Recibe los pedidos pagados de tu tienda Shopify para confirmar conversiones reales.',
  integration_shopify_secret_label: 'Signing secret de Shopify',
  integration_shopify_secret_help:
    'Pega aquí el secret que Shopify te muestra al crear el webhook en Settings → Notifications.',
  integration_shopify_secret_replace_help:
    'Reemplazar el secret invalida la integración hasta que pegues uno nuevo.',
  integration_shopify_secret_placeholder: 'Pega el signing secret de Shopify',
  integration_shopify_secret_required: 'Pega el signing secret de Shopify',
  integration_shopify_replace_secret: 'Reemplazar secret',
  integration_shopify_steps_title: 'Cómo configurarlo en Shopify',
  integration_shopify_step_1:
    'Entra a tu Shopify Admin → Settings → Notifications.',
  integration_shopify_step_2:
    'Baja a "Webhooks" y haz click en "Create webhook".',
  integration_shopify_step_3:
    'Configura: Event "Order payment", Format "JSON", URL: pega la de arriba.',
  integration_shopify_step_4:
    'Después de crear el webhook, Shopify te muestra un signing secret. Pégalo aquí abajo.',
  integration_shopify_docs_link: 'Ver documentación oficial de Shopify',
  integration_shop_domain_label: 'Dominio de la tienda (opcional)',
  integration_shop_domain_help:
    'Ej: mi-tienda.myshopify.com. Si lo dejas vacío, lo capturamos del primer webhook recibido.',

  integration_generic_title: 'Endpoint genérico',
  integration_generic_description:
    'Para Stripe, Mercado Pago o cualquier sistema custom: postea conversiones a nuestra URL desde tu backend.',
  integration_generic_example_title: 'Ejemplo cURL',

  integration_webhook_url_label: 'URL del webhook',
  integration_endpoint_url_label: 'URL del endpoint',
  integration_api_key_label: 'Tu API key',
  integration_api_key_hidden_help:
    'Solo mostramos los últimos 4 caracteres por seguridad. Si la perdiste, regenera una nueva.',
  integration_api_key_generate: 'Generar API key',
  integration_api_key_rotate: 'Regenerar API key',
  integration_api_key_generated: 'API key generada',
  integration_save: 'Guardar',
  integration_saved: 'Integración guardada',
  integration_save_failed: 'No se pudo guardar la integración',
  integration_disable: 'Desactivar',
  integration_disabled: 'Integración desactivada',
  integration_copy: 'Copiar',
  integration_copied: '¡Copiado!',
  integration_status_active: 'Activa',
  integration_status_configured_no_traffic: 'Sin tráfico',
  integration_status_inactive: 'No configurada',

  credential_modal_title: 'Tu credencial',
  credential_modal_description:
    'Cópiala ahora — por seguridad no podrás verla de nuevo.',
  credential_modal_warning:
    'Guárdala en un lugar seguro. Si la pierdes tendrás que regenerar una nueva.',
  credential_modal_copy: 'Copiar',
  credential_modal_copied: 'Copiado',
  credential_modal_close: 'Cerrar',

  list_verified_conversions_label: 'Conversiones verificadas',
  list_verified_revenue_label: 'Ingresos',
  list_verified_revenue_mixed: 'multi-divisa',
  list_verified_revenue_mixed_tooltip:
    'Las conversiones llegaron en distintas monedas — el total no está convertido.',
  list_verified_empty_no_data: 'Esperando primera conversión',
  list_verified_empty_no_integration:
    'Conecta una integración para ver compras reales',
  list_stat_goal_achieved: 'Meta',
  list_stat_goal_achieved_tooltip:
    'Porcentaje de conversaciones donde el agente concluyó que se cumplió el objetivo (vender, calificar, agendar, etc.). Es la opinión del LLM al leer el chat — útil pero subjetivo. Para compras reales, mira "Verificadas".',
  list_stat_convs_tooltip:
    'Conversaciones únicas en los últimos 7 días. La gráfica muestra la tendencia diaria.',
  list_stat_verified_short: 'Verificadas',
  list_stat_verified_tooltip_data:
    'Conversaciones con al menos una compra verificada por una integración externa (Shopify, endpoint genérico). Es ground truth — no opinión del LLM.',
  list_verified_tooltip_revenue: 'Ingresos',
  list_verified_tooltip_sources: 'Por fuente',
  section_links_title: 'Enlaces',
  section_links_subtitle:
    'URLs oficiales que el agente comparte cuando el cliente las necesita.',

  field_display_name_label: 'Nombre visible',
  field_brand_name_label: 'Nombre de marca',
  field_persona_name_label: 'Nombre de la persona del agente',
  field_persona_name_help: 'Así se presenta el agente en las conversaciones.',
  field_brand_description_label: 'Descripción',
  field_brand_description_help:
    'Contexto de marca que se inyecta al system prompt.',
  field_default_language_label: 'Idioma por defecto',
  field_timezone_label: 'Zona horaria',
  field_llm_provider_label: 'Proveedor',
  field_llm_model_label: 'Modelo',
  field_llm_model_help:
    'Identificador del modelo según el proveedor (ej. gpt-4o-mini, claude-sonnet-4-5).',
  field_llm_temperature_label: 'Temperature',
  field_llm_temperature_help: '0 = predecible, 1 = creativo.',
  field_tone_description_label: 'Descripción del tono',
  field_tone_description_help:
    'Texto libre que describe la personalidad. Se inyecta al system prompt.',
  field_preferred_words_label: 'Palabras preferidas',
  field_preferred_words_help:
    'Vocabulario de marca que el agente debe priorizar.',
  field_forbidden_words_label: 'Palabras prohibidas',
  field_forbidden_words_help:
    'Se evitan siempre y se bloquean en las respuestas.',
  field_qa_examples_label: 'Ejemplos de estilo',
  field_qa_examples_help:
    'Pares que muestran el tono ideal. Se usan como few-shot.',
  field_qa_question_label: 'Pregunta del cliente',
  field_qa_answer_label: 'Respuesta ideal',
  field_system_prompt_label: 'System prompt (extra)',
  field_system_prompt_help:
    'Se inyecta después de la descripción de marca y el tono.',
  field_data_fields_label: 'Datos a recolectar',
  field_data_fields_help:
    'Grupos de campos con condiciones opcionales que ramifican la conversación.',
  field_available_labels_label: 'Etiquetas disponibles',
  field_agent_capabilities_label: 'Capacidades',
  field_agent_limitations_label: 'Límites (nunca hace)',
  field_goal_type_label: 'Tipo de objetivo',
  field_goal_primary_outcome_label: 'Resultado principal',
  field_goal_primary_outcome_help: 'Qué significa "éxito" para este agente.',
  field_goal_aggressiveness_label: 'Agresividad del CTA',
  field_goal_aggressiveness_help: 'Qué tan directo es al pedir la venta.',
  field_goal_min_turns_label: 'Turnos mínimos antes del CTA',
  field_goal_min_turns_help:
    'Nunca pide la venta antes de este número de mensajes.',
  field_goal_milestones_label: 'Hitos antes del CTA',
  field_goal_milestones_help:
    'Condiciones que deben cumplirse antes de que el agente pida la venta.',
  field_goal_opening_style_label: 'Estilo de apertura',
  field_goal_opening_examples_label: 'Ejemplos de apertura',
  field_messaging_conciseness_label: 'Concisión',
  field_messaging_conciseness_help: 'Qué tan breve responde el agente.',
  field_messaging_split_strategy_label: 'Estrategia de división',
  field_messaging_max_messages_label: 'Mensajes máximos por turno',
  field_messaging_target_chars_label: 'Caracteres objetivo por mensaje',
  field_messaging_image_cooldown_label: 'Enfriamiento de imágenes (minutos)',
  field_messaging_image_cooldown_help:
    'Minutos mínimos entre dos respuestas con imagen.',
  field_rag_enabled_label: 'Retrieval-Augmented Generation',
  field_rag_enabled_help:
    'Cuando está activo, el agente busca en tus fuentes antes de responder.',
  field_tools_enabled_label: 'Herramientas externas',
  field_tools_enabled_help:
    'Funciones que el agente puede llamar (APIs, bases de datos, webhooks).',
  field_handoff_enabled_label: 'Pasar a un humano',
  field_handoff_enabled_help:
    'Cuando está activo, el agente se detiene y notifica a un humano si alguna condición se cumple.',
  field_handoff_triggers_label: 'Disparadores',
  field_handoff_message_label: 'Mensaje de escalamiento',
  field_handoff_message_help:
    'Mensaje que se le muestra al cliente cuando el agente escala.',
  quiet_hours_default_title: 'Quiet hours por defecto',
  quiet_hours_default_help:
    'Bloque de horas en que no se enviarán follow-ups. Cada regla puede sobrescribir esto.',
  quiet_hours_using_custom: 'Usando configuración propia',
  rule_new_default_name: 'Nueva regla',
  rule_add_custom: 'Añadir regla',
  rule_remove: 'Eliminar regla',
  rule_empty: 'No hay reglas configuradas. Añade una para empezar.',
  rule_badge_builtin: 'Built-in',
  field_followup_master_enabled_label: 'Activar follow-ups',
  field_followup_master_enabled_help:
    'Cuando está apagado, ningún follow-up se dispara para este agente.',
  field_quiet_hours_default_enabled_label: 'Aplicar quiet hours por defecto',
  field_quiet_hours_enabled_label: 'Aplicar quiet hours',
  field_quiet_hours_start_label: 'Inicio',
  field_quiet_hours_end_label: 'Fin',
  field_quiet_hours_days_label: 'Días',
  field_quiet_hours_override_label: 'Quiet hours específicas para esta regla',
  field_quiet_hours_override_help:
    'Si está apagado, usa los quiet hours por defecto del agente.',
  field_use_default_quiet_label: 'Usar default',
  field_followup_rules_label: 'Reglas de follow-up',
  field_followup_rules_help:
    'Built-in (no se pueden borrar, solo deshabilitar) y reglas custom que tú definas.',
  field_rule_name_label: 'Nombre',
  field_rule_enabled_label: 'Activar esta regla',
  field_delay_hours_label: 'Esperar (horas)',
  field_delay_hours_help: 'El reloj pausa durante quiet hours.',
  field_cancel_if_goal_met_label:
    'No enviar si el agente ya cumplió su objetivo',
  field_cancel_if_goal_met_help:
    'Recomendado. Si el cliente ya hizo lo que el agente buscaba (p. ej. comprar), este recordatorio no se envía.',
  field_message_override_enabled_label: 'Personalizar mensaje',
  field_message_override_enabled_help:
    'Si está apagado, la IA escribe el mensaje basado en la marca y el contexto.',
  field_message_text_label: 'Mensaje',
  field_message_text_help:
    'Variables disponibles: {{customer_name}}, {{brand_name}}, {{rule_name}}, {{cart_count}}, {{cart_total}}.',
  field_message_text_placeholder:
    'Hola {{customer_name}}, ¿pudiste pensarlo? Estoy aquí para ayudarte.',
  rule_summary_after: 'Después de',
  rule_summary_skip_if_goal: 'salta si el objetivo se cumplió',
  day_sun: 'Dom',
  day_mon: 'Lun',
  day_tue: 'Mar',
  day_wed: 'Mié',
  day_thu: 'Jue',
  day_fri: 'Vie',
  day_sat: 'Sáb',
  field_links_privacy_label: 'Política de privacidad',
  field_links_terms_label: 'Términos y condiciones',
  field_links_help_label: 'Ayuda / contacto',
  field_links_about_label: 'Sobre la marca',
  field_links_payment_label: 'URL base de pago',
  field_links_catalog_label: 'Catálogo / producto principal',

  field_links_label: 'Enlaces de la marca',
  field_links_help:
    'URLs que el agente puede compartir con el cliente. Cada enlace tiene una descripción que le dice al agente qué es y cuándo enviarlo.',
  field_link_url_label: 'URL',
  field_link_description_label: 'Descripción',
  field_link_description_help:
    'Qué es este enlace y cuándo enviarlo. El agente lee esto para decidir si compartir el enlace en una conversación.',
  field_link_description_placeholder:
    'p. ej. Política de reembolso — envíalo cuando el cliente pregunte por devoluciones dentro de 30 días.',
  field_link_cta_label: 'Texto del botón (override)',
  field_link_cta_help:
    'Texto exacto del botón para este enlace. Déjalo vacío para que el modelo lo genere (≤20 caracteres).',
  field_link_cta_placeholder: 'p. ej. Pagar ahora',
  field_link_type_label: 'Tipo',
  field_link_type_help:
    'Ayuda al agente a priorizar y agrupar los enlaces. Opcional.',
  field_link_type_placeholder: 'Elige un tipo…',
  field_link_type_product: 'Producto',
  field_link_type_payment: 'Pago',
  field_link_type_privacy_policy: 'Política de privacidad',
  field_link_type_terms: 'Términos',
  field_link_type_help_option: 'Ayuda / contacto',
  field_link_type_about: 'Sobre la marca',
  field_link_type_faq: 'FAQ',
  field_link_type_social: 'Redes sociales',
  field_link_type_other: 'Otro',
  field_optional_suffix: 'opcional',
  links_item_title: 'Enlace {{index}}',
  links_add: 'Agregar enlace',
  links_remove: 'Eliminar enlace',
  links_empty:
    'Aún no hay enlaces — agrega uno para que el agente lo comparta.',
  links_open: 'Abrir enlace',

  goal_type_sell_label: 'Vender',
  goal_type_sell_desc: 'Lleva la conversación hacia una compra.',
  goal_type_support_label: 'Soporte',
  goal_type_support_desc: 'Resuelve dudas y problemas.',
  goal_type_qualify_label: 'Calificar',
  goal_type_qualify_desc: 'Recolecta datos para el equipo comercial.',
  goal_type_book_label: 'Agendar',
  goal_type_book_desc: 'Lleva a reservar una cita o demo.',
  goal_type_prospect_label: 'Prospectar',
  goal_type_prospect_desc: 'Identifica y califica posibles clientes.',

  list_summary: '{{active}} activos · {{paused}} pausados',
  list_filter_label: 'Filtrar agentes',
  list_filter_all: 'Todos',
  list_filter_active: 'Activos',
  list_filter_paused: 'Pausados',
  list_filter_draft: 'Borradores',
  list_search_placeholder: 'Buscar por agente o marca…',
  list_search_loading: 'Buscando…',
  list_search_error: 'No se pudo buscar. Inténtalo de nuevo.',
  list_sort_label: 'Ordenar por',
  list_sort_updated: 'Recientes',
  list_sort_name: 'Nombre',
  list_view_label: 'Modo de vista',
  list_view_grid: 'Vista en cuadrícula',
  list_view_list: 'Vista en lista',
  list_col_agent: 'Agente',
  list_col_status: 'Estado',
  list_col_channels: 'Cuentas',
  list_col_volume: 'Volumen',
  list_col_trend: 'Tendencia',
  list_no_channels: 'Sin canales',
  list_no_match_title: 'No hay agentes que coincidan',
  list_no_match_description: 'Prueba con otro filtro o crea uno nuevo.',
  list_stat_convs: 'Conv. (7d)',
  list_stat_convs_short: 'conversaciones',
  list_stat_conversion: 'Conversión',
  list_action_test: 'Probar',
  list_action_configure: 'Configurar',
  list_footer_hint_title: '¿Quieres una segunda opinión sobre tu mejor agente?',
  list_footer_hint_description:
    '{{brand}} AI puede revisar las conversaciones y sugerir mejoras concretas al tono, las objeciones más comunes y los hitos antes del CTA.',
  list_estimate_label: 'Est.',
  list_estimate_tooltip:
    'Estimación con muestreo — agente de alto volumen. Calculada sobre el 30% de las conversaciones y extrapolada.',
  list_stale_label: 'Dato desactualizado',
  list_stale_tooltip:
    'Sin conversaciones nuevas en las últimas horas, así que el rollup no se ha refrescado.',
  list_traffic_label: 'Origen del tráfico',
  list_traffic_organic: 'Orgánicas',
  list_traffic_ads: 'Ads',
  list_traffic_empty: 'Sin tráfico aún',

  // Playground (chat with your agent, no channel attached)
  playground_title: 'Probar agente',
  playground_subtitle: 'Conversa con tu agente sin pasar por WhatsApp. Es el mismo agente y la misma configuración; solo el canal es distinto.',
  playground_open: 'Probar',
  playground_empty_title: 'Escribe el primer mensaje',
  playground_empty_body: 'Habla como lo haría un cliente. El agente abre según su objetivo configurado.',
  playground_reset: 'Reiniciar conversación',
  playground_reset_done: 'Conversación reiniciada',
  playground_reset_failed: 'No se pudo reiniciar la conversación',
  playground_send_failed: 'El agente no pudo responder',
  playground_empty_reply: 'El agente no devolvió texto en este turno.',
  playground_trace_title: 'Traza del turno',
  playground_trace_nodes: 'Nodos',
  playground_trace_intent: 'Intención',
  playground_trace_tone: 'Tono del lead',
  playground_trace_tools: 'Herramientas',
  playground_trace_empty: 'Envía un mensaje para ver la traza.',
  playground_human_active: 'Un humano tomó el control de este hilo.',
  playground_disclaimer: 'Las acciones son reales: lo que el agente cree queda guardado.',
  playground_test_mode: 'Modo prueba',
  playground_send: 'Enviar',
  playground_placeholder: 'Escribe como lo haría un cliente…',
};
